export const WELLNESS_PLAN_ERROR_CODES = {
  ALREADY_SUBSCRIBED: "SCRATCHPAY_ALREADY_SUBSCRIBED",
  MONTHLY_DENIED: "SCRATCHPAY_MONTHLY_DENIED",
  TRANSACTION_NOT_FOUND: "SCRATCHPAY_TRANSACTION_NOT_FOUND",
  SUBSCRIPTION_NOT_FOUND: "SCRATCHPAY_SUBSCRIPTION_NOT_FOUND",
  UNAUTHORIZED_TRANSACTION: "SCRATCHPAY_UNAUTHORIZED_TRANSACTION",
  NOT_CONFIGURED: "SCRATCHPAY_NOT_CONFIGURED",
  PET_NOT_FOUND: "SCRATCHPAY_PET_NOT_FOUND",
  PLAN_NOT_FOUND: "SCRATCHPAY_PLAN_NOT_FOUND",
  INVALID_PHONE: "SCRATCHPAY_INVALID_PHONE",
  USER_NOT_FOUND: "SCRATCHPAY_USER_NOT_FOUND",
} as const;
